import script from "./InvoiceCustomerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceCustomerCard.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceCustomerCard.vue?vue&type=style&index=0&id=06deebaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06deebaa"]])

export default __exports__